// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"b4eb0668","453":"136d3566","934":"ac3d13c4"}[chunkId] + ".chunk.js";
};